<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="ResolDeltaSolCsPlus_2d00"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import ResolDeltaSolCsPlus_2d00 from '@/device-products/ResolDeltaSolCsPlus_2d00.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: ResolDeltaSolCsPlus_2d00, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
